export default {
  title: "Protocols",
  subtitle: "Company PDF protocols for staff reference.",
  empty: "No protocols match these filters.",
  emptyWritable: "Upload the first protocol PDF.",
  template: {
    download: "Download template",
  },
  filters: {
    searchPlaceholder: "Search by title",
    statusLabel: "Status",
    statusAll: "All statuses",
    categoryLabel: "Category",
    categoryPlaceholder: "e.g. Devices, Ops",
    tagLabel: "Tags",
    tagAll: "All tags",
    tagCount: "{{count}} selected",
  },
  tags: {
    label: "Tags",
    placeholder: "Select or add tags",
    searchPlaceholder: "Search tags…",
    create: "Add “{{name}}”",
  },
  status: {
    ACTIVE: "Active",
    SUSPENDED: "Suspended",
    OBSOLETE: "Obsolete",
  },
  actions: {
    view: "View",
    download: "Download",
    edit: "Edit",
    versions: "Versions",
    addVersion: "Add new version",
    markObsolete: "Mark obsolete",
    more: "More actions",
  },
  obsolete: {
    title: "Mark protocol obsolete?",
    body: "“{{title}}” will leave the Active list. Version history is kept; new versions cannot be published until it is set back to Active.",
    confirm: "Mark obsolete",
    success: "Protocol marked obsolete",
  },
  upload: {
    title: "Upload protocol",
    titleLabel: "Title",
    titlePlaceholder: "e.g. Evacuation plan",
    categoryLabel: "Category",
    categoryPlaceholder: "e.g. Devices",
    statusLabel: "Status",
    fileLabel: "PDF file",
    dropzoneTitle: "Drop a PDF here, or click to browse",
    dropzoneDescription: "PDF only, max 20 MB",
    submit: "Upload",
    success: "Protocol uploaded",
  },
  edit: {
    title: "Edit protocol",
    submit: "Save",
    success: "Protocol updated",
  },
  versions: {
    title: "Versions — {{title}}",
    publishTitle: "Add new version — {{title}}",
    current: "Current",
    loadError: "Could not load versions",
    bumpLabel: "Version type",
    bumpMinor: "Minor",
    bumpMinorDescription: "Small updates or corrections.",
    bumpMajor: "Major",
    bumpMajorDescription: "Significant rewrite or policy change.",
    changeSummaryLabel: "What changed",
    changeSummaryPlaceholder: "Optional notes about what changed in this version…",
    changeSummaryHint: "Optional",
    submit: "Publish version",
    success: "New version published",
    publishBlocked: "Reactivate this protocol (set status to Active) before publishing a new version.",
  },
  errors: {
    titleRequired: "Enter a title",
    fileRequired: "Choose a PDF file",
    fileTooLarge: "{{name}} is too large. Max size is {{max}}.",
    loadError: "Could not load protocols",
  },
} as const;
